

















import { Component, Vue, Prop } from "vue-property-decorator";

// Provider

@Component({
  components: {
    "ticket-feed-provider": () =>
      import("@/components/app/global/tickets/ticketFeedProvider.vue"),
    "ticket-message-form": () =>
      import("@/components/app/global/tickets/ticketMessageForm.vue"),
    "ticket-messages": () =>
      import("@/components/app/global/tickets/ticketMessages.vue")
  }
})
export default class TicketFeed extends Vue {
  @Prop({ default: false })
  public isStaged!: boolean;
}
